export default {
  setHubTenants(state, tenants) {
    state.hubTenants = tenants;
  }
};
